import { render, staticRenderFns } from "./LesiurpackagesTheme2.vue?vue&type=template&id=ed86b1aa&scoped=true"
import script from "./LesiurpackagesTheme2.vue?vue&type=script&lang=js"
export * from "./LesiurpackagesTheme2.vue?vue&type=script&lang=js"
import style0 from "./LesiurpackagesTheme2.vue?vue&type=style&index=0&id=ed86b1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed86b1aa",
  null
  
)

export default component.exports